import { css } from 'styled-components'
import dogLickImg from '../../../../images/stickers/dog-lick.gif'
import eatPrayMoneyImg from '../../../../images/stickers/eat-pray-money.gif'
import emoji1Img from '../../../../images/stickers/emoji1.gif'
import emoji2Img from '../../../../images/stickers/emoji2.gif'
import gifGroupImg from '../../../../images/stickers/gifgroup.gif'
import legoImg from '../../../../images/stickers/lego.gif'
import skaterImg from '../../../../images/stickers/skater.gif'
import peeker1Img from '../../../../images/stickers/01_peeker.gif'
import peeker2Img from '../../../../images/stickers/02_peeker.gif'
import carouselDarkImg from '../../../../images/phone-mock/carousel_dark.gif'
import carouselLightImg from '../../../../images/phone-mock/carousel_light.gif'
import waterfallDarkImg from '../../../../images/phone-mock/waterfall_dark.gif'
import waterfallLightImg from '../../../../images/phone-mock/waterfall_light.gif'
import searchImg from '../../../../images/phone-mock/search.gif'
import contentTypeImg from '../../../../images/phone-mock/content_types.gif'

export const slideContent = [
    {
        leftHeader: 'Customizable UI',
        leftText:
            'Toggle between different layouts, color themes and display options with the touch of a button. For the first time, no two GIPHY’s are alike.',
        rightHeader: undefined,
        rightText: undefined,
        isToggle: true,
        leftIndex: 1,
        rightIndex: 2,
    },
    {
        leftHeader: 'Exclusive Content',
        leftText:
            'SDK drops an infinite library of high quality GIFs and Stickers directly into your app: All the classics, content from our top tier partners, GIPHY artists, GIPHY originals, and everything else you won’t find anywhere else.',
        rightHeader: 'GIPHY Emoji & Text',
        rightText:
            'Our latest content releases, like animated emoji and text, as well as access to future GIPHY features, are only available through GIPHY SDK. ',
        leftIndex: 1,
        rightIndex: 2,
    },
    {
        leftHeader: 'Unmatched Search',
        leftText:
            'A powerful search algorithm developed by our world class engineering team and vetted by the biggest apps is now yours. Deliver the right GIF, at the right time, every time.',
        rightHeader: 'Smart Analytics',
        rightText:
            'What good is the best content without the tools to match? Our analytics learn from user behavior to help us deliver smarter results and boost user engagement.',
        leftIndex: 1,
        rightIndex: 2,
    },
]

export const phoneImages: any = [
    {
        dark: { vertical: waterfallDarkImg, horizontal: carouselDarkImg },
        light: { vertical: waterfallLightImg, horizontal: carouselLightImg },
    },
    { src: contentTypeImg },
    { src: searchImg },
]

export const slide2Stickers = (showSecondSlideEmojis: boolean) => [
    {
        src: dogLickImg,
        className: css`
            width: 114px;
            top: 55%;
            left: 27.5%;
            transition: transform 200ms ease-in-out;
            transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
        `,
    },
    {
        src: eatPrayMoneyImg,
        className: css`
            width: 170px;
            top: 10%;
            left: 100%;
            transition: transform 200ms ease-in-out 0.1s;
            transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
        `,
    },
    {
        src: emoji1Img,
        className: css`
            width: 78px;
            top: 20%;
            left: 75%;
            transition: transform 200ms ease-in-out 0.2s;
            transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
        `,
    },
    {
        src: emoji2Img,
        className: css`
            width: 78px;
            top: 20%;
            left: 82%;
            transition: transform 200ms ease-in-out 0.3s;
            transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
        `,
    },
    {
        src: gifGroupImg,
        className: css`
            width: 236px;
            top: -15%;
            left: -15%;
            transition: transform 200ms ease-in-out 0.4s;
            transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
        `,
    },
    {
        src: legoImg,
        className: css`
            width: 200px;
            top: 75%;
            left: 100%;
            transition: transform 200ms ease-in-out 0.5s;
            transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
        `,
    },
    {
        src: skaterImg,
        className: css`
            width: 230px;
            top: 66%;
            left: -21%;
            transition: transform 200ms ease-in-out 0.6s;
            transform: ${showSecondSlideEmojis ? 'scale(1)' : ''};
        `,
    },
]

export const slide3Stickers = (showThirdSlideEmojis: boolean) => [
    {
        src: peeker1Img,
        className: css`
            width: 230px;
            top: -14.6%;
            left: 0%;
            transition: transform 200ms ease-in-out 0.1s;
            transform: ${showThirdSlideEmojis ? 'scale(1)' : ''};
        `,
    },
    {
        src: peeker2Img,
        className: css`
            width: 230px;
            top: 80.9%;
            right: 0%;
            transition: transform 200ms ease-in-out 0.2s;
            transform: ${showThirdSlideEmojis ? 'scale(1)' : ''};
        `,
    },
]
